<template>
    <div class="wrapper multiple_linkedform">
        <!-- 头图 -->
        <header>
            <img :src="ui.head" alt="头图" class="header_img" />
        </header>
        <div :style="`backgroundColor:${ui.bg_color}`" ref="main" class="main_wrapper" style="margin: -2px 0;">
            <!-- 倒计时 -->
            <!-- <countDown v-if="ui.is_counter" :labelColor="ui.font_color" :stime="stime"></countDown> -->
            <div class="form_wrapper " ref="form_wrapper">
                <!-- 表单部分 -->
                <van-form ref="actionForm" class="actionForm">
                    <p class="vant_label" :style="{ color: `${ui.font_color}` ? `${ui.font_color}` : '#000' }">您所在的城市
                    </p>
                    <van-field v-model="action_form.city" readonly placeholder="请选择您所在的城市" @click="clk_city"
                        right-icon="play" />
                    <p class="vant_label" :style="{ color: `${ui.font_color}` ? `${ui.font_color}` : '#000' }">选择您的意向车型
                    </p>
                    <van-field v-model="action_form.car_name" readonly placeholder="意向车型(品牌+车型)" @click="clk_brand"
                        right-icon="play" />
                    <p class="vant_label" :style="{ color: `${ui.font_color}` ? `${ui.font_color}` : '#000' }">您的姓名</p>
                    <van-field v-model="action_form.name" name="姓名" maxlength="36" placeholder="请输入您的姓名" />
                    <p class="vant_label" :style="{ color: `${ui.font_color}` ? `${ui.font_color}` : '#000' }">
                        您的手机号码(已加密)
                    </p>
                    <van-field type="tel" maxlength="11" v-model="action_form.phone" name="电话" placeholder="请输入您的手机号码">
                    </van-field>

                    <div class="form_btn" @click="submitForm" :style="`backgroundColor: ${ui.btn_bg_color};`">
                        <span :style="`color: ${is_opacity}`">{{ ui.btn_text }}</span>
                        <img src="../../assets/image/new_img/pointer_01.png" alt="手" class="pointer_img">
                        <div class="threeCircle threeCircle_1"></div>
                        <div class="threeCircle threeCircle_2"></div>
                        <div class="threeCircle threeCircle_3"></div>
                    </div>
                    <div class="policy_wrapper">
                        <policy :custom_col="ui.font_color"></policy>
                    </div>
                </van-form>
            </div>
            <!-- 走马灯-->
            <banner v-if="ui.is_banner"></banner>
        </div>
        <div class="detail_img" :class="ui.is_copyright ? '' : 'pb_20'">
            <!-- 详情图-->
            <img :src="ui.tail" alt="详情图" class="detail_img" ref="tailImage" />
        </div>
        <!-- 版权-->
        <div>
            <copyright v-if="ui.is_copyright"></copyright>
        </div>
        <div v-if="btn_show" class="footer_wrapper">
            <div class="bottom_btn" @click="btn_click_form"
                :style="`backgroundColor: ${ui.btn_bg_color};color: ${ui.btn_font_color}`">
                {{ ui.btn_text }}
            </div>
        </div>

        <!--车型弹框 vant-->
        <van-popup v-model="is_dialog_car" round position="bottom" :style="{ height: '80%', width: '100%' }">
            <carlist_monitor_noletter :activity_id="Number(activity_id)" :custom_car="Number(custom_car)"
                :city="action_form.city" :brand_list="brand_list" :is_dialog_car="is_dialog_car" @query="query_car"
                @handleClose="handleClose"></carlist_monitor_noletter>
        </van-popup>

        <!-- 报名成功弹框-->
        <el-dialog :visible.sync="is_success" v-if="is_success" class="Successful" width="50%">
            <el-result icon="success" title="报名成功"></el-result>
        </el-dialog>

        <!--  城市弹框-->
        <van-popup v-model="city_show" round position="bottom" :style="{ height: '80%', width: '100%' }">
            <city_letter :is_dialog_city="city_show" @query="query_city" @handleClose="handleCloseCity"></city_letter>
        </van-popup>
    </div>
</template>

<script>
import countDown from "@/components/countDown";
import policy from "@/components/policy";
import copyright from "@/components/copyright";
import banner from "@/components/banner";
import city_letter from "@/components/city_letter";
import carlist_monitor_noletter from "@/components/carlist_monitor_noletter";
import _geturl from "@/utils/_geturl";
import lib_activity from "@/libs/lib_activity";
import _wx from "@/common/_wx";
import _time from "@/utils/_time";
import _object from "@/utils/_object";
import _regular from "@/utils/_regular";
import lib_requirement from "@/libs/lib_requirement";
import lib_success from "@/libs/lib_success";
import cache_url from "@/cache/cache_url";
import Toast from "vant/lib/toast";
import _monitor from "@/monitor/_monitor";

let action_form = {
    brand_name: '', //品牌名称
    series_name: '', // 车型名称
    brand_id: 0,  // 品牌id
    series_id: 0, // 车型id
    automaker_id: 0,
    car_name: '', //品牌/车型名称
    name: '', // 姓名
    phone: '', //电话
    city: '', //城市
}

export default {
    name: "multiple_common",
    components: {
        carlist_monitor_noletter,
        city_letter,
        countDown,
        policy,
        copyright,
        banner,
    },
    data() {
        return {
            title: '', // document的title
            activity_id: 1469, //活动ID
            custom_car: 0, // 是否自定义车型库
            tids: "", //模板ID
            channel: '', //渠道
            channel_name: '', //渠道名
            tid: 0, // 有无车型库
            share_theme: '', //分享描述
            stime: 0, // 项目开始时间
            etime: 0, // 项目结束时间
            ui: {
                head: '', //头图
                tail: '', //详情图
                share: '', //分享图
                bg_color: '', //表单背景色
                font_color: '', //文本颜色
                btn_bg_color: '', //按钮背景色
                btn_font_color: '', //按钮文本颜色
                btn_text: '', //按钮文本值
                btm_btn_text: '', //底部按钮文本
                is_banner: 0, //是否有轮播图
                is_counter: 0, //是否有倒计时
                is_copyright: 1, //协议
                jmp_url: 0, //0-报名成功;1-帮朋友报名;2-置换二手车;3-邮寄门票
            },

            action_form: action_form,
            require_id: '', // 车型库ID
            //城市联级选择
            citys: [], //城市数据
            cascaderProps: { //配置项
                expandTrigger: 'hover', //展开方式
                value: "id", //指定选项的值
                label: "name", //指定选项标签
                children: "children", //指定选项的子选项
                emitPath: false, //该节点数组
            },

            is_dialog_car: false, //车型弹框
            is_success: false, //报名成功弹框
            // is_city: false, //表单城市项，默认无城市
            is_stop: false, //活动是否已结束
            is_display: true, //底部按钮
            btn_show: false, //底部按钮显隐
            series_name: "请选择意向车型",

            city_show: false,
            cascaderValue: '',
            cityNames: {
                text: 'name',
                value: 'id',
                children: 'children',
            },

            brand_list: [], //品牌列表
        }
    },
    created() {
        // 地址栏
        this.activity_id = _geturl("activity_id");
        this.tids = _geturl("tids");
        this.channel = _geturl("channel");
        this.channel_name = _geturl("channel_name");

        //获取项目信息
        lib_activity.info(this.activity_id, this.tids, this.init_info);
        //监测
        _monitor.init(this.channel, this.activity_id);

    },
    mounted() {
        // 监听页面滚动
        window.addEventListener('scroll', this.handleScroll, true)
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll, true)
    },
    destroyed() {
    },
    methods: {
        //初始化项目信息
        init_info(data) {
            console.log(data)
            this.title = data.activity.theme;
            document.title = this.title;
            this.share_theme = data.activity.share_theme;
            this.etime = data.activity.etime;
            this.stime = data.activity.stime;
            this.tid = data.activity.tid;
            this.custom_car = data.activity.custom_car;
            if (data.ui == null) {
                this.ui = {};
                return;
            }
            this.ui = data.ui;
            console.log(this.ui, '===')
            // 项目结束
            if (!data.activity.state || (_time._current() > data.activity.etime)) {
                this.is_stop = true;
                return;
            }


            // 分享： ui存在再分享
            if (_object._length(this.ui) > 0) {
                this.share();
            }
        },
        // 分享
        share() {
            let that = this;
            lib_activity.share(function (data) {
                let options = {};
                options.title = that.title;
                options.desc = that.share_theme;
                options.link = window.location.href;
                options.image = that.ui.share;

                _wx.js_api(data, _wx.share, options);
            })
        },

        clk_city() {
            this.city_show = true;
        },
        // 选择车型弹框展现
        clk_brand() {
            if (!this.action_form.city) {
                Toast('请选择城市');
                return;
            }
            this.is_dialog_car = true;
        },

        query_car(brand_name, series_name, require_id) {
            this.require_id = require_id;
            this.action_form.brand_name = brand_name;
            this.action_form.series_name = series_name;
            this.action_form.car_name = brand_name + '/' + series_name;
            this.is_dialog_car = false;
        },
        // 选择城市弹框展现
        query_city(city_name, brand) {
            this.action_form.car_name = city_name == this.action_form.city ? this.action_form.car_name : '';
            this.action_form.city = city_name;
            this.brand_list = brand.split(',').map(item => item.trim());
            this.city_show = false;
        },


        submitForm() {
            if (!this.action_form.city) {
                Toast('请选择城市');
                return;
            }
            if (!this.action_form.name) {
                Toast('请输入您的姓名');
                return;
            }
            if (this.action_form.name && this.action_form.name.length > 20) {
                Toast('请输入正确的姓名');
                return;
            }
            if (!this.action_form.phone) {
                Toast('请输入您的手机号');
                return;
            }
            if (!_regular.is_mobile(this.action_form.phone)) {
                Toast('请输入正确的手机号');
                return;
            }
            if (this.action_form.series_name == '') {
                Toast('请选择品牌车型');
                return;
            }

            let url = window.location.href;
            let form_ui_id = this.ui.hasOwnProperty("id") ? this.ui.id : 0;
            let params = {
                activity_id: this.activity_id,
                channel_code: this.channel,
                channel_name: this.channel_name,
                url,
                name: this.action_form.name,
                phone: this.action_form.phone,
                series: this.action_form.series_name,
                form_ui_id,
                require_id: this.require_id,
            };
            console.log(params, 'params');
            let that = this;
            lib_requirement.atbclue(params, function (data) {
                //监测上报
                _monitor.submit()

                //缓存当页面链接
                cache_url.set(window.location.href)
                //不同参数跳转不同页面
                const jmp_url = _object._length(that.ui) > 0 ? that.ui.jmp_url : 0
                //跳转地址
                const url = lib_success.jmp_url(jmp_url)
                that.$router.push({
                    path: url,
                    query: {
                        id: data.id
                    },
                })
            })
        },

        // 滚到表单开始部分
        btn_click_form() {
            let form_top = this.$refs.main.offsetTop - 50;
            document.documentElement.scrollTop = form_top
            document.body.scrollTop = form_top
            document.querySelector('#app').scrollTop = form_top
        },
        // 滚动
        handleScroll() {
            let scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || document.querySelector('#app').scrollTop;
            this.$nextTick(() => {
                if (scrollHeight >= this.$refs.tailImage.offsetTop) {
                    this.is_display = false;
                    this.btn_show = true;
                } else {
                    this.is_display = true;
                    this.btn_show = false;
                }
            })
        },

        handleClose(flag) {
            this.is_dialog_car = flag;
        },
        handleCloseCity(flag) {
            this.city_show = flag;
        }
    },
    watch: {
        is_dialog_car(val) {
            let scrollWidth = document.innerWidth - document.documentElement.offsetWidth;
            if (val) {
                document.body.style.overflow = 'hidden';
                document.body.style.paddingRight = scrollWidth + 'px'
            } else {
                document.body.style.overflow = 'scroll';
                document.body.style.paddingRight = scrollWidth + 'px'
            }
        }
    },
    computed: {
        is_opacity: function () {
            return this.is_stop ? this.ui.btn_font_color + '80' : this.ui.btn_font_color
        }
    }
};
</script>

<style lang="less" scoped>
@import "../../assets/style/autoshow/base.less";
@import "../../assets/style/autoshow/form.less";
@import "../../assets/style/global.less";
@import "../../assets/style/common/successful.less"; //报名成功

.multiple_linkedform {
    :deep .van-button::before {
        background-color: transparent;
    }

    .vant_label {
        font-size: 26px;
        margin: 0 0 10px 0;
    }

    .form_btn {
        width: 100%;
        height: 88px;
        background: #ff011f;
        position: relative;
        border-radius: 12px;
        margin-bottom: 25px;
        margin-top: 40px;

        span {
            width: 100%;
            position: absolute;
            line-height: 88px;
            font-size: 44px;
            color: #fff;
            letter-spacing: 1px;
            text-align: center;
            left: 0;
            font-family: 'OPPOSans-B';
        }
    }

    .pointer_img {
        z-index: 99;
        right: -10px;
        bottom: -50px;
        animation: moveThreeCircleFinger 2s ease infinite both;
    }

    .policy_wrapper {
        display: flex;
        justify-content: center;
    }

    :deep .van-cell::after {
        border: none;
    }

    .actionForm {
        .van-cell {
            border: solid 2px #f1f1f2;
            border-radius: 10px;
            display: flex;
            align-items: center;
            margin-bottom: 20px;
            padding-top: 0 !important;
            padding-bottom: 0 !important;
            line-height: 70px;
        }

        :deep .van-field__value {
            padding-left: 16px;
            // padding-right: 35px;
        }

        :deep .van-radio__icon .van-icon {
            border-radius: 4px !important;
        }

        :deep .van-cell__right-icon {
            height: 80px;
            display: flex;
            align-items: center;
        }

        :deep .van-field__right-icon {
            transform: rotate(90deg);
            margin-right: 0;
            color: #a0a4ac;
        }
    }

    .phone_btn {
        background: transparent;
    }
}
</style>
